<template>
  <div class="List">
    <Head :Catedetails="catemessage"></Head>

    <div class="content" v-if="prolist.length !== 0">
      <!-- <div v-if="prolist.length !== 0"> -->
      <router-link
        :to="{ path: '/Details', query: { id: item.id, cid: cid, key: key } }"
        v-for="(item, index) in prolist"
        :key="index"
      >
        <Item :listitem="item"> </Item>
      </router-link>
    </div>
    <div class="content" v-else style="height: 8.92rem">
      <!-- <div style="height: 2rem"></div> -->
      <el-result icon="info" title="没有产品" subTitle="等待管理人员添加">
        <!-- <template slot="extra">
          <el-button type="primary" size="medium">返回</el-button>
        </template> -->
      </el-result>

      <!-- <el-tag>没有产品，等待添加</el-tag> -->
    </div>
    <Gohome></Gohome>
    <div class="nav">
      <Navitem :list="navlist" @navid="navgetid"></Navitem>
    </div>
  </div>
</template>

<script>
import Head from '../../components/Head.vue'
import Gohome from '../../components/Gohome.vue'
import Item from '../../components/Item.vue'
import Navitem from '../../components/Navitem.vue'
import { Catelist, Listdata, subCatelist } from '@/api/Home'
export default {
  components: {
    Head,
    Item,
    Gohome,
    Navitem,
  },
  data() {
    return {
      navlist: [],
      prolist: [],
      catemessage: null,
      cid: null,
      pid: 0,
      key: 0,
      // 是否有产品信息
      iscateshow: false,
      // Catedetail: null,
    }
  },
  created() {
    // console.log(this.$router.query.cid)
    this.catedata()
  },
  mounted() {},
  methods: {
    async catedata() {
      this.cid = this.common.urlget('cid')
      const { data: res } = await subCatelist(this.cid)
      if (res.code === 1) {
        console.log(res.data.categories[0].id)
        this.navlist = res.data.categories
        this.catemessage = this.navlist[0]
        this.pid = res.data.categories[0].id
        this.getlistdata()
      }
    },

    // 产品列表信息
    async getlistdata() {
      const { data: res } = await Listdata(this.pid)
      if (res.code == 1) {
        this.prolist = res.data.data
      }
    },
    navgetid(e, s) {
      this.pid = e
      this.key = s
      this.getlistdata()
      // console.log(this.navlist[s])
      this.catemessage = this.navlist[s]
    },
  },
}
</script>
 
<style lang="less" scoped>
.List {
  // position: absolute;
  width: 100vw;
  overflow: hidden;
  height: auto;
  box-sizing: border-box;
  // position: relative;
  // min-width: 3000px;
  .content {
    box-sizing: border-box;
    width: 100vw;
    height: auto;
    margin-top: 1.12rem;
    padding: 0 3.22rem;
    display: flex;
    flex-wrap: wrap;
  }
  .nav {
    position: absolute;
    right: 0.6rem;
    top: 13.59rem;
    width: 2.5rem;
    height: 5rem;
    // background: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Product/List.vue